module.exports = __webpack_public_path__ + "static/img/qrcode.fd84c33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode.jpg
// module id = 192
// module chunks = 1